<template>
  <div v-if="canShowAvailableBalance" class="footer__low-availability">
    <v-icon small color="error">
      mdi-alert-circle-outline
    </v-icon>

    <span class="footer__low-availability-balance">
      {{ $t('recharge.lowAvailabilityBalance.currentBalance') }}:
      <strong>
        {{ balance ? this.catalogMonetary(balance) : '---' }}
      </strong>
    </span>

    <a href="/recharge?createRecharge=true">
      {{ $t('recharge.lowAvailabilityBalance.requestMore') }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { catalogMonetary } from '@/util/catalog'

/**
 * The balance pill. Positioning lives on the parent (`FooterNotices`) so that this component and the
 * trial pill can appear and disappear on their own terms — neither one's condition may decide whether
 * the other is drawn.
 */
export default {
  name: 'LowAvailableBalanceFooter',

  data() {
    return {
      catalogMonetary,
      noAvailableBalanceWarning: ['login', 'rootLogin', 'quote', 'onboarding', 'onboardingSteps'],
    }
  },

  computed: {
    ...mapGetters(['balance', 'showAvailableBalance']),

    routesToShowAvailableBalance() {
      return !this.noAvailableBalanceWarning.includes(this.$route.name)
    },

    isBrazil() {
      return localStorage.getItem('user_country') === 'BR'
    },

    canShowAvailableBalance() {
      return this.isBrazil && this.routesToShowAvailableBalance && this.showAvailableBalance
    },
  },
}
</script>
